export const baseMap = {
   name: 'Norges grunnkart - gråtone',
   wmsUrl: 'https://opencache.statkart.no/gatekeeper/gk/gk.open?',
   wmtsCapabilitiesUrl: 'https://opencache.statkart.no/gatekeeper/gk/gk.open_wmts?Version=1.0.0&service=wmts&request=getcapabilities',
   layer: 'norges_grunnkart_graatone',
   maxZoom: 18,
   equidistance: 5,
   updated: '2018-01-17'
};